import { Navigate, Route } from "react-router-dom";

/** Addresses that went away, and the page that now holds what they showed, so old links and bookmarks still land. */
export const MOVED: ReadonlyArray<{ from: string; to: string }> = [
  // The Network page: its setting is on Policies, each computer's speed and rating on its person's page.
  { from: "/network", to: "/policies" },
];

/** One redirect route per moved address; it replaces the old address in the history, so Back does not bounce. */
export function movedRoutes() {
  return MOVED.map(({ from, to }) => <Route key={from} path={from} element={<Navigate to={to} replace />} />);
}
